import {setLocalStorageAuth} from 'PaymentAPI';

const initialState = {
  fetching: false,
  fetched: false,
  token: '',
  expiresIn: null,
  createdAt: null,
  user: null,
  error: null,
  loggedAs: 'GUEST',
  preference: [],
  loggedAsPost: null,
  redirectUrl: null,
  selectedIban:null,
};
export const authReducer = (state = initialState, action) => {

  let result = {...state};

  switch (action.type) {
    case 'SET_AUTH': {
      result = (action.auth == null) ? {...initialState} : {...action.auth};
      break;
    }
    case 'SET_AUTH_USER': {
      result = {...state, user: action.user};
      break;
    }
    case 'SET_AUTH_TOKEN': {
      result = {...state, token: action.token};
      break;
    }

    case 'SET_CURRENT_CLIENT_PENDING': {
      result = { ...state, updating: true, updated: false };
      break;
    }

    case 'SET_CURRENT_CLIENT_FULFILLED': {

      let loggedAs = 'CONTACT';
      let loggedAsPost = null;
      const { user } = state;
      const currentClient = action.payload;

      if (currentClient) {
        if (currentClient.authorisation && currentClient.authorisation.role) {
          loggedAs = currentClient.authorisation.role;
        }

        if (user && Array.isArray(user.roles)) {
          const role = user.roles.find(({ organization: { id } }) => id == currentClient.id);
          if (role && role.type) {
            loggedAsPost = role.type;
          }
        }
      }

      const {paymentClients} = state.user;
      let clients = [];

      if(paymentClients) {
        clients = paymentClients.map((client) => ({
          ...client,
          isSelected : client.id == currentClient.id
        }))
      }
      result = {
        ...state,
        updating: false,
        updated: true,
        loggedAs,
        loggedAsPost,
        preference: currentClient.authorisation.preferences || [],

        currentClient,
        user: {...state.user, paymentClients: clients}
      };
      break;
    }

    case 'SET_CURRENT_CLIENT_REJECTED': {
      let error = action.payload;
      switch (error && error.response && error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          }
          break;
        default:
      }
      return {
        ...state,
        updating: false,
        updated: false,
        error
      };
      break;
    }

    case 'UPDATE_PAYMENT_CLIENTS_AUTHORIZATION': {
      const { role, clientId, allowShowOrganizationBalance} = action.payload;
      if (!state.user) return state;
      if (!state.user.paymentClients) return state;
      return {
        ...state,
        preference : {allowShowOrganizationBalance : allowShowOrganizationBalance ? 1 : 0},
        user: {
          ...state.user,
          paymentClients: state.user.paymentClients.map(item => ((clientId === item.id)
            ? {
              ...item,
              authorisation:
                {
                  id: item.authorisation && item.authorisation.id,
                  preference : {allowShowOrganizationBalance : allowShowOrganizationBalance},
                  role,
                },
            }
            : item))
        }
      };
    }

    case 'SET_EXPIRES_IN': {
      result = {...state, expiresIn: action.expiresIn};
      break;
    }
    case 'SET_TOKEN_CREATED_AT': {
      result = {...state, createdAt: action.createdAt};
      break;
    }
    case 'SET_AUTH_LOGGED_AS': {
      result = {...state, loggedAs: action.loggedAs};
      break;
    }
    case 'FETCH_AUTH_USER_PENDING': {
      result = {...state, fetching: true};
      break;
    }
    case 'SET_USER_LOGGED_WITH_TOKEN':
    case 'FETCH_AUTH_USER_FULFILLED': {
      const user = action.payload;
      const {paymentClients} = user;
      let loggedAs = 'GUEST';
        let currentClient = null;
        let loggedAsPost = null;
      let hasClients = paymentClients && paymentClients.length>0;
        let preference = [];
        if(hasClients){
            loggedAs = 'CONTACT';
            currentClient = paymentClients[0];
          // currentClient = paymentClients.filter(({isSelected}) => isSelected)[0];
           if(currentClient && currentClient['authorisation'] && currentClient['authorisation'].role){
                loggedAs = currentClient['authorisation'].role;
                preference = currentClient['authorisation'].preferences;
            }

          if (currentClient && user && Array.isArray(user.roles)) {
            const role = user.roles.find(({ organization: { id } }) => id == currentClient.id);
            if (role && role.type) {
              loggedAsPost = role.type;
            }
          }
        }
        result = {
            ...state,
            fetching: false,
            fetched: true,
            loggedAs,
            loggedAsPost,
            preference,
            user,
            currentClient
        };
      break;
    }
    case 'FETCH_AUTH_USER_REJECTED': {
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
      break;
    }

    case 'SET_URL': {
        const data = action.payload;
        return {
            ...state,
            redirectUrl: data,
        };
          break;
      }
      case 'STORE_IBAN': {
          return {...state, selectedIban: action.selectedIban};
          break;
      }
    default:
      return state;
  }
  setLocalStorageAuth(result);
  return result;
};



// WEBPACK FOOTER //
// ./app/reducers/index/auth.js